<template>
  <div
    class="bg-section-1 h-screen bg-no-repeat bg-cover relative overflow-hidden"
  >
    <img
      class="flower-1 absolute m-auto h-95vh left-0 bottom-0 z-10 opacity-0"
      :src="`${imgPath}/Section01/animation-flower-1.png`"
    />
    <img
      class="flower-2 absolute m-auto h-7vh left-0.1/10 top-2/10 z-20 opacity-0"
      :src="`${imgPath}/Section01/animation-flower-2.png`"
    />
    <img
      class="flower-7 absolute m-auto h-13vh left-0 bottom-0 z-30 opacity-0"
      :src="`${imgPath}/Section01/animation-flower-6.png`"
    />
    <img
      class="flower-3 absolute m-auto h-20vh left-0.4/10 top-7/10 z-20 opacity-0"
      :src="`${imgPath}/Section01/animation-flower-3.png`"
    />
    <img
      class="flower-4 absolute m-auto h-17vh left-1.2/10 top-7/10 z-20 opacity-0"
      :src="`${imgPath}/Section01/animation-flower-4.png`"
    />
    <img
      class="flower-5 absolute m-auto h-13vh left-4.9/10 bottom-0 z-40 opacity-0"
      :src="`${imgPath}/Section01/animation-flower-7.png`"
    />
    <img
      class="flower-6 absolute m-auto h-13vh left-5.3/10 -bottom-0.5/10 z-40 opacity-0"
      :src="`${imgPath}/Section01/animation-flower-8.png`"
    />

    <!-- devil -->
    <img
      class="devil absolute m-auto h-30vh left-0.3/10 top-4/10 z-20 opacity-0"
      :src="`${imgPath}/Section01/animation-char-5.png`"
    />
    <!-- black hair -->
    <img
      class="black-hair absolute m-auto h-105vh left-1.3/10 -bottom-1/10 opacity-0"
      :src="`${imgPath}/Section01/animation-char-3.png`"
    />
    <!-- white hair -->
    <img
      class="white-hair absolute m-auto h-105vh left-1/10 bottom-0/10 z-30 opacity-0"
      :src="`${imgPath}/Section01/animation-char-0.png`"
    />
    <!-- fairy -->
    <img
      class="fairy absolute mx-auto w-20vh inset-x-0 top-0.5/10 z-20 opacity-0"
      :src="`${imgPath}/Section01/animation-char-1.png`"
    />
    <!-- red hair -->
    <img
      class="red-hair absolute mx-auto h-85vh left-4.5/10 bottom-0.5/10 z-10 opacity-0"
      :src="`${imgPath}/Section01/animation-char-2.png`"
    />
    <!-- play button -->
    <a
      class="flex"
      href="https://www.youtube.com/watch?v=TvHaoJwXx0Q"
      data-lity
    >
      <img
        class="play-btn absolute mx-auto h-20vh inset-x-0 top-2.6/10 z-50 opacity-0"
        :src="`${imgPath}/Section01/animation-movie.png`"
      />
    </a>
    <!-- logo -->
    <img
      class="logo absolute mx-auto h-60vh inset-x-0 bottom-1/10 z-40 opacity-0"
      :src="`${imgPath}/Section01/web-logo.png`"
    />
    <!-- chain effect -->
    <img
      class="chain-effect absolute mx-auto h-45vh right-0 top-0 opacity-0"
      :src="`${imgPath}/Section01/animation-effect-1.png`"
    />
    <!-- fire effect -->
    <img
      class="fire-effect absolute mx-auto h-100vh right-0 top-0 z-30 opacity-0"
      :src="`${imgPath}/Section01/animation-effect-2.png`"
    />
    <!-- background flower -->
    <img
      class="bg-effect-1 absolute w-full h-full left-0 top-0 z-10 opacity-0"
      :src="`${imgPath}/Section01/animation-flower-9.png`"
    />
    <!-- background flower -->
    <img
      class="bg-effect-2 absolute w-full h-full inset-x-0 mx-auto top-0 z-10 opacity-0"
      :src="`${imgPath}/Section01/animation-effect-3.png`"
    />
    <!-- big flower effect -->
    <img
      class="big-flower absolute h-17vh right-0.8/10 top-3.5/10 opacity-0"
      :src="`${imgPath}/Section01/animation-flower-2.png`"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  methods: {
    initAnimation: function() {
      this.$store.commit('ANIMATION/TOP_SECTION');
    },
  },
  computed: {
    ...mapState({
      imgPath: state => state.AppConfig.imgPath,
    }),
  },
  created: function() {
    window.addEventListener('load', this.initAnimation);
  },
};
</script>

<style lang="postcss" scoped></style>
